import {useLocation} from 'react-router-dom';
import qs from 'qs';

// В отличие от useSearchParam из react-use, читает параметр из роутера,
// поэтому на сервере (StaticRouter) и на клиенте значение одинаковое.
// qs вместо URLSearchParams: в mini_racer (SSR) нет Web API.
const useQueryParam = (name: string): string | null => {
  const
    {search} = useLocation(),
    value = qs.parse(search, {ignoreQueryPrefix: true})[name];

  return typeof value === 'string' ? value : null;
};

export default useQueryParam;
